import React from 'react';
import SettingsForm from '../../components/SettingsForm';
import PersonalSettingsForm from '../../components/PersonalSettingsForm';

import { Card, CardHeader, Row, Col, CardBody, FormGroup, Input, Label } from 'reactstrap';
import Waitable from '../../components/Waitable';
import { toast } from 'react-toastify';

export default class Settings extends React.Component {

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitPersonalSettings = this.onSubmitPersonalSettings.bind(this);
  }

  onSubmitPersonalSettings(formData) {
    const { dispatchUpdateSelf } = this.props;

    dispatchUpdateSelf({
      self: {
        ...formData
      }
    }, (err, result) => {
      if (err) {
        toast.error(err.message);
      } else {
        toast.success("Updated!");
      }
    })
  }

  onSubmit(formData) {
    const { dispatchUpdateSettings, dispatchGetSettings } = this.props;

    if (formData.terminals) {
      let terminalIds = Object.keys(formData.terminals);

      let terminals = terminalIds.map(id => {
        return {
          terminalId: id,
          email: formData.terminals[id]
        };
      });
      formData.terminals = terminals;
    }
    dispatchUpdateSettings(formData, (err, data) => {
      if (err) {
        toast.error(err.message);
      }
      else {
        toast.success("Settings Updated");
        dispatchGetSettings();
      }
    });
  }
  render() {
    const { settings, terminals } = this.props;
    let defaultSettings = {};
    if (settings.get("data")) {
      defaultSettings = settings.get("data");
    }

    let settingsData = settings.get("data");
    let initialValues = {
      terminals: {}
    };
    if (settingsData) {
      initialValues.bannerText = settingsData.bannerText;
      settingsData.terminals.forEach(terminal => {
        initialValues.terminals[terminal.terminalId] = terminal.email;
      });
      initialValues.blacklist = settingsData.blacklist
    }


    return <div className="animated fadeIn">
      <Row>



        <Col md="6" >
          <Card>
            <Waitable entities={[settings]}>
              <CardHeader>
                <i className="fa fa-align-justify"></i> Global Dashboard Settings
              </CardHeader>
              <CardBody>
                <SettingsForm
                  terminals={terminals}
                  initialValues={initialValues}
                  currentValues={defaultSettings}
                  onSubmit={this.onSubmit}
                />
              </CardBody>
            </Waitable>
          </Card>
        </Col>
        <Col md="6" >
          <Card>
            <Waitable entities={[settings]}>
              <CardHeader>
                <i className="fa fa-align-justify"></i> Personal Settings
              </CardHeader>
              <CardBody>

                <PersonalSettingsForm

                  onSubmit={this.onSubmitPersonalSettings}
                />


              </CardBody>
            </Waitable>
          </Card>
        </Col>
      </Row>
    </div>;

  }
}


// WEBPACK FOOTER //
// ./src/views/Settings/Settings.js